import React from 'react';

import { KnownService, KnownServiceComponentProps } from './known-service';

import styles from './styles.less';

interface OwnProps extends KnownServiceComponentProps {
  url: string;
  user: string;
  repo: string;
  issueNumber: string;
}

export const GitHubPullRequestComponent: React.FunctionComponent<OwnProps> = ({
  user,
  url,
  repo,
  issueNumber,
  ...anchorProps
}) => (
  <a {...anchorProps} href={url} className={styles.knownServiceLink}>
    <img
      className={styles.knownServiceIcon}
      alt="Github Icon"
      src={require('resources/images/services/github.png')}
    />
    {user}/{repo}: Pull Request {issueNumber}
  </a>
);

export const GitHubPullRequest: KnownService<OwnProps> = {
  match: {
    protocol: 'https:',
    host: 'github.com',
    pathname: new RegExp(`\
^\
/\
([^/]+)/\
([^/]+)/\
pull/\
(\\d+)\
$\
`),
  },
  getMatchProps: ([url, _, user, repo, issueNumber]: string[]) => {
    return { url, user, repo, issueNumber };
  },
  Component: GitHubPullRequestComponent,
};
